import React from 'react';
import './icon.scss';
var conversionTable = {
  'småretter': 'smalldishes',
  'sauser-og-dressinger': 'sauce',
  'lunsj': 'lunch',
  'tilbehør': 'extras',
  'drikke': 'drink',
  'middag': 'dinner',
  'kaker': 'cake',
  'frokost': 'breakfast',
  'bakst': 'bread',
  'vegetar': 'vegetarian',
  'desserter': 'dessert',
  'hovedråvare': 'vegetarian',
  'sesong': 'halloweenpumpkin',
  'nasjonalitet': 'smalldishes',
  'annet': 'chef_hat'
};
export var Icon = function (_ref) {
  var icon = _ref.icon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var iconConverted = conversionTable[icon] || icon;
  return /*#__PURE__*/React.createElement("span", {
    "aria-label": icon,
    className: "a-icon a-icon-".concat(iconConverted).concat(size ? " a-icon-".concat(size) : '', " ").concat(className)
  });
};
export default Icon;